import classes from "./Menu.module.css";
import MediaS from "../MediaS";
import logo from "../../../store/logo.png"
import {useEffect, useState} from "react";
import ModalView from "../Modal/ModalView";
import axios from 'axios';
import { path, assetsBaseUrl } from "../../../routes"
import {CircularProgress} from "@mui/material";

const Menu = (props) =>{
    const [user, setUser] = useState(props.cred);
    const [loading, setLoading] = useState(true);

    const temp = {
        id: 0,
        Header: "Namespace",
        Body: {
            file: "",
            imgURL: logo,
            elevators: [
                {
                    name: "E1_",
                    checked: false
                },
                {
                    name: "E2_",
                    checked: true
                },
                {
                    name: "E3_",
                    checked: false
                }
            ]
        }
    }
    const [idCount, setIdCount] = useState(1);
    const [currentID, setCurrentID] = useState(null);
    const [cards, setCards] = useState([])
    const [cardsNew, setCardsNew] = useState([])
    const [modalLoaded, setModalLoaded] = useState(false);
    const [modalVariant, setModalVariant] = useState(null);
    const [images, setImages] = useState([]);
    const [fileContent, setFileContent] = useState('');
    const [modalBodyUpdate,setmodalBodyUpdate]=useState({
        name:"",
        device:null,
        date:"2020-11-11 00:00:00",
        dateFrom:"2020-11-11 00:00:00",
        dateTo:"2020-11-11 00:00:00",
        room:"A-D"
    })
    const [modalBody, setModalBody] = useState({
        file: "",
        text: "testik",
        v1: false,
        v2: true,
        v3: true
    });
    const [carouselIndex, setCarouselIndex] = useState(0);
    const fetchDataCards = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${path}/getCardsMenu`);
            setObje(response.data || []);
        } catch (error) {
            console.error('Error loading cards:', error);
        } finally {
            setLoading(false);
        }
    }
    const setObje =  (x) =>{
        let fld=[]
        for(let i = 0;i<x.length;i++){
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }
    const delete_hanler = (id) => {
        setCurrentID(id)
        setModalVariant(0)
        setModalLoaded(true)
    }
    const preview_handler = (id) =>{
        for (let i = 0;i<cards.length;i++){
            if (cards[i].id == id){
                setModalVariant(2)
                setModalBody(cards[i])
                setCarouselIndex(i)
                setModalLoaded(true)
            }
        }
    }
    const edit_handler = (id) => {
        for (let i = 0;i<cards.length;i++){
            if (cards[i].id == id){
                setCurrentID(id)
                setModalVariant(1)
                setModalBody(cards[i])
                setModalLoaded(true)
            }
        }
    }
    const add_hanler = (id) => {
        setModalVariant(1)
        setModalBody(null)
        setCurrentID(null)
        setModalLoaded(true)
    }
    const modal_close_handler = (id) => {
        setModalVariant(null)
        setModalLoaded(false)
        setModalBody(null)
        fetchDataCards()

    }
    const add_toCards_handler = (card) => {
        setCards([...cards, card])
        setIdCount(idCount + 1)
    }
    const delete_fnc = async (id) => {

        for (let i = 0;i<cards.length;i++){
            //let tempY = cards
            if ( id === cards[i].id){
                const pathFile = cards[i].Body.file;
                //console.warn(cards[i])
                cards.splice(i, 1)
                try {
                    await axios.delete(`${path}/deleteRow/${id}`)
                    console.log('Row deleted successfully');
                    // Optionally, update your UI to reflect the deletion
                } catch (error) {
                    console.error('Error deleting row:', error);
                }

            }
            // id === cards[i].id? cards.splice(i, 1):console.log("upsii")
        }
        console.log("deleting id no. ",id)

    }
    useEffect(()=>{
        fetchDataCards();
    },[]);

    return <div className={classes.cont}>
        {loading && (
            <div className={classes.loader}>
                <CircularProgress size={40} />
            </div>
        )}
        {!loading && cards.map(x => (
            <MediaS typ={2} key={x.id} delete={delete_hanler} body={x.Body} text={x.Header} id={x.id} preview={preview_handler} edit={edit_handler}/>
        ))}
        {modalLoaded &&
            <ModalView V={modalVariant} ModalBody={modalBody} close={modal_close_handler} add={add_toCards_handler}
                       addID={idCount} currentID={currentID} delFNC={delete_fnc} cred={user} modalBodyUpdate={modalBodyUpdate}
                       carouselItems={cards} carouselIndex={carouselIndex} groupID={99} updateCount={fetchDataCards}/>}


    </div>
}
export default Menu